import styled from 'styled-components';

export const Container = styled.button`
  background: none;
  height: 56px;
  width: 100%;
  padding: 0 0.875rem;
  display: flex;
  align-items: center;
  border: 1px solid ${Styles.color.grey.four};
  border-radius: ${Styles.borderRadius};
  transition: background-color 0.15s;
  cursor: pointer;
  ${Styles.desktop`
    &:hover {
      background-color: ${Styles.color.grey.five};
    }
  `}
`;

export const TextWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  p {
    font-size: 1rem;
  }
`;
